const Warning = () => {
    return <p style={{ "font-size": "46px", margin: "0" }}>⚠️</p>;
};

export default Warning;
